/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { cloneDeep } from 'lodash'

import type { ElasticsearchCluster, ElasticsearchClusterInstance } from '@modules/ui-types'

import type { SetInstanceCapacityAction } from '@/actions/stackDeployments/types'

export default function setInstanceCapacity(
  cluster: ElasticsearchCluster,
  action: SetInstanceCapacityAction,
) {
  const nextCluster = cloneDeep(cluster)

  const { instanceIds, instanceCapacity } = action.meta

  // We expect the find the instance by its ID
  const instances = instanceIds
    .map((id) => nextCluster.instances.record.find((each) => each.name === id))
    .filter((each): each is ElasticsearchClusterInstance => each != null)

  instances.forEach((instance) => {
    const currentMemoryCapacity = instance.capacity.memory
    const currentStorageCapacity = instance.capacity.storage ?? 0
    const storageCapacity = (instanceCapacity * currentStorageCapacity) / currentMemoryCapacity

    instance.capacity.memory = instanceCapacity
    instance.capacity.storage = storageCapacity
  })

  return nextCluster
}
